import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import LibraryMenu from "./LibraryMenu";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate, useParams } from "react-router-dom";

import moment from "moment";

import Pagination from "../General/Pagination";
import csvDownload from "json-to-csv-export";

function IssuanceReport(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );

  const [listOfLedger, setLedger] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showFilters, setShowFilters] = useState(true);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [StartDate, setStartDate] = useState(
    moment().subtract(2, "months").format(config.date_format_input)
  );
  const [EndDate, setEndDate] = useState(
    moment().format(config.date_format_input)
  );

  useEffect(() => {
    setLoading(true);
    setIsUpdated(true);
    document.title = "Issuance Report ";

    const dashboardParms = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      StartDate: StartDate,
      EndDate: EndDate,
    };

    //console.log(dashboardParms);

    var api_config = {
      method: "post",
      url: config.base_url + "Library/GetIssuanceReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: dashboardParms,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code != 0) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          setIsUpdated(false);
          setLoading(false);
        } else {
          setLedger(null);
          setTotalRecords(0);
          setIsUpdated(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [UserID, AccessKey, StartDate, EndDate, pageNo, pageSize]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const issuedTo = (item) => {
    if (item.Student_Name) {
      return `${item.Student_Name}${item.Student_Registration ? " (" + item.Student_Registration + ")" : ""}`;
    }
    if (item.Employee_Name) {
      return `${item.Employee_Name}${item.Employee_Code ? " (" + item.Employee_Code + ")" : ""}`;
    }
    return "";
  };

  const exportCsv = () => {
    if (!listOfLedger || listOfLedger.length === 0) {
      toast.error("No data to export.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    csvDownload({
      data: listOfLedger.map((item) => ({
        Book_Name: item.Name_Of_Book,
        Issue_Date: item.Date_Of_Issue ? moment(item.Date_Of_Issue).format(config.date_format) : "",
        Due_Date: item.Return_Date ? moment(item.Return_Date).format(config.date_format) : "",
        Issued_To: issuedTo(item),
        Remarks: item.Remarks || "",
      })),
      filename: "library-issuance-report",
    });
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Name_Of_Book}</td>
            <td>{moment(item.Date_Of_Issue).format("DD/MM/YYYY")}</td>
            <td>{item.Return_Date ? moment(item.Return_Date).format("DD/MM/YYYY") : ""}</td>
            <td>{issuedTo(item)}</td>
            <td>{item.Remarks}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="6">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <LibraryMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Library/LibraryDashboard">
                        Library
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Issuance Report
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Issuance Report</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/Library/ViewLibrary"
                    className="button button-white button-icon"
                  >
                    Manage Library
                    <i className="ri-file-list-2-line"></i>
                  </NavLink>
                  <button
                    onClick={() => {
                      setShowFilters((prevIsActive) => !prevIsActive);
                    }}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div
              className={`collapse ${showFilters ? "show" : ""} `}
              id="collapseFilteres"
            >
              <div className="card mb-2">
                <div className="card-body p-md-4">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Start Date :</label>

                        <input
                          type="date"
                          value={StartDate || ""}
                          className="form-control"
                          onChange={(e) => setStartDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>End Date :</label>
                        <input
                          type="date"
                          value={EndDate || ""}
                          className="form-control"
                          onChange={(e) => setEndDate(e.target.value)}
                          max={moment().format(config.date_format_input)}
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="counting mt-4 text-end">
                        <span className="">{totalRecords} </span> Records Found!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body table_card">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Book Name</th>
                      <th>Issuance Date</th>
                      <th>Due Date</th>
                      <th>Issued To</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colspan="7">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                </table>
                {totalRecords > pageSize && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value));
                              }}
                            >
                              <option value="10" selected>
                                10
                              </option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="card mt-md-3">
              <div className="card-body">
                <div className="row justify-content-end text-end gy-2">
                  <div className="col-md-auto">
                    <button type="button" className="button button-white" onClick={exportCsv}>
                      Export CSV
                    </button>
                  </div>
                  <div className="col-md-auto">
                    <NavLink
                      target="_blank"
                      to={`/Library/PrintIssuanceReport/?startDate=${StartDate}&EndDate=${EndDate}`}
                      className="button button-primary "
                    >
                      Print This Report
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IssuanceReport;
